import React from 'react';
import Icon from '@/components/ui/AppIcon';

const StatsSection = () => {
  const stats = [
    {
      icon: 'UserGroupIcon',
      value: '2,500+',
      label: 'Happy Clients',
      color: 'text-accent',
    },
    {
      icon: 'StarIcon',
      value: '4.9/5',
      label: 'Average Rating',
      color: 'text-accent',
    },
    {
      icon: 'ClockIcon',
      value: '15+',
      label: 'Years Experience',
      color: 'text-accent',
    },
    {
      icon: 'CheckBadgeIcon',
      value: '98%',
      label: 'Success Rate',
      color: 'text-success',
    },
  ];

  return (
    <div data-component-id="src/app/testimonials/components/StatsSection.tsx:33:4" data-component-path="src/app/testimonials/components/StatsSection.tsx" data-component-line="33" data-component-end-line="50" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20lg%3Agrid-cols-4%20gap-6%22%7D" className="grid grid-cols-2 lg:grid-cols-4 gap-6">
      {stats.map((stat, index) => (
        <div data-component-id="src/app/testimonials/components/StatsSection.tsx:35:8" data-component-path="src/app/testimonials/components/StatsSection.tsx" data-component-line="35" data-component-end-line="48" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20rounded-xl%20p-6%20text-center%20shadow-cosmic%20hover%3Ashadow-cosmic-lg%20transition-all%20duration-300%20border%20border-border%22%7D"
          key={index}
          className="bg-card rounded-xl p-6 text-center shadow-cosmic hover:shadow-cosmic-lg transition-all duration-300 border border-border"
        >
          <div data-component-id="src/app/testimonials/components/StatsSection.tsx:39:10" data-component-path="src/app/testimonials/components/StatsSection.tsx" data-component-line="39" data-component-end-line="43" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20mb-4%22%7D" className="flex justify-center mb-4">
            <div data-component-id="src/app/testimonials/components/StatsSection.tsx:40:12" data-component-path="src/app/testimonials/components/StatsSection.tsx" data-component-line="40" data-component-end-line="42" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-16%20h-16%20bg-secondary%2F20%20rounded-full%20flex%20items-center%20justify-center%22%7D" className="w-16 h-16 bg-secondary/20 rounded-full flex items-center justify-center">
              <Icon data-component-id="src/app/testimonials/components/StatsSection.tsx:41:14" data-component-path="src/app/testimonials/components/StatsSection.tsx" data-component-line="41" data-component-end-line="41" data-component-file="StatsSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={stat.icon as any} size={32} className={stat.color} />
            </div>
          </div>
          <div data-component-id="src/app/testimonials/components/StatsSection.tsx:44:10" data-component-path="src/app/testimonials/components/StatsSection.tsx" data-component-line="44" data-component-end-line="46" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22font-headline%20text-3xl%20font-bold%20text-foreground%20mb-2%22%7D" className="font-headline text-3xl font-bold text-foreground mb-2">
            {stat.value}
          </div>
          <div data-component-id="src/app/testimonials/components/StatsSection.tsx:47:10" data-component-path="src/app/testimonials/components/StatsSection.tsx" data-component-line="47" data-component-end-line="47" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-sm%20text-muted-foreground%20font-body%22%7D" className="text-sm text-muted-foreground font-body">{stat.label}</div>
        </div>
      ))}
    </div>
  );
};

export default StatsSection;